import { Component } from '@angular/core';

@Component({
  selector: 'app-about-intro',
  templateUrl: './about-intro.component.html',
  styleUrls: ['./about-intro.component.scss']
})
export class AboutIntroComponent {
  // Data oficial do Dia de Doar 2026: 01/12/2026
  // O mês 11 representa dezembro, pois no JavaScript os meses começam em 0.
  date: Date = new Date(2026, 11, 1);
}